// extracted by mini-css-extract-plugin
export default {"host":"style_host__85evj","table":"style_table__IBwZ8","fixedLayout":"style_fixedLayout__Jzt4+","headerRow":"style_headerRow__aCzxk","pseudoBorder":"style_pseudoBorder__GeyRO"};